module.exports = __webpack_public_path__ + "img/schedule.1346b571.svg";